
import HeroSection from './Sections/HeroSection';
import AboutSection from './Sections/AboutSection';
import AtuacaoSection from './Sections/AtuacaoSection';
import ProcessSection from './Sections/ProcessSection';
import ContactSection from './Sections/ContactSection';
import ServicesSection from './Sections/ServicesSection';
import ProjetoGallery from './Sections/ProjetoGallery';
import SEOHead from '../../components/SEOHead';
import { organizationSchema, serviceSchema, breadcrumbSchema, faqSchema } from '../../utils/schemas.js';


export default function Home() {
    // Combinando todos os schemas estruturados
    const combinedSchema = {
        "@context": "https://schema.org",
        "@graph": [
            organizationSchema,
            serviceSchema,
            breadcrumbSchema,
            faqSchema
        ]
    };
    const galleryImages = [
        { id: 1, src: require('../../assets/images/Fotos1.jpeg'), title: 'Galpão Industrial Uberlândia' },
        { id: 2, src: require('../../assets/images/Fotos2.jpeg'), title: 'Terraplenagem em Araguari' },
        { id: 3, src: require('../../assets/images/Fotos3.jpeg'), title: 'Infraestrutura Urbana Araxá' },
        { id: 4, src: require('../../assets/images/Fotos4.jpeg'), title: 'Edificação Comercial Patos de Minas' },
        { id: 5, src: require('../../assets/images/Fotos5.jpeg'), title: 'Pavimentação Rodoviária Uberaba' },
        { id: 6, src: require('../../assets/images/Fotos6.jpeg'), title: 'Obra Residencial Belo Horizonte' },
        ];

    return (
        <>
            <SEOHead
                title="HN Engenharia e Construções - Soluções Completas em Engenharia Civil | Projetos e Consultoria"
                description="HN Engenharia: especialistas em projetos estruturais, consultoria técnica e gerenciamento de obras. Soluções inovadoras em engenharia civil com qualidade garantida."
                keywords="engenharia civil, projetos estruturais, consultoria engenharia, gerenciamento obras, laudos técnicos, engenharia estrutural, construção civil, HN Engenharia"
                structuredData={combinedSchema}
            />
            <HeroSection />
            <AboutSection />
            <AtuacaoSection />
            <ProcessSection />
            <ServicesSection />
            <ProjetoGallery images={galleryImages} />
            <ContactSection />
        </>
    );
}
